import { Issue, Article } from '../../../constants';
import { createContext } from 'react';

export const Context = createContext<ContextProps>({
	issues: [],
	isLoading: true,
	articles: [],
});

interface ContextProps {
	issues: Array<Issue>;
	isLoading: boolean;
	articles: Array<Article>;
}

export interface FeaturedArticle {
	article: Article;
	url: string;
}
